import {BoidAllocation} from "./BoidAllocation";
import {statusFor} from "./BoidAssignmentState";

/**
 * For assignment purposes, BOIDs can be aggregated into one of two
 * data structures:
 *
 * <ul>
 *   <li>
 *     A list of currently assigned BOIDs
 *   </li>
 *   <li>
 *     A map of BOIDs to {@link BoidAssignmentState}
 *    </li>
 * </ul>
 *
 * @see {@link BoidAllocation}
 * @see {@link BoidAssignmentState}
 */
export type BoidAggregationType = string[] | BoidAllocation;

/**
 * The {@link BoidGroup} data structure holds a collection of BOID data
 * grouped by type.
 *
 * @see {@link BoidAggregationType}
 */
export interface BoidGroup<T = BoidAggregationType> {
  type: string;
  boids: T;
}

export type BoidGroupPredicate<T> = (group: BoidGroup<T>) => boolean;

export const groupTypeEquals =
  <T>(type: string): BoidGroupPredicate<T> =>
  group =>
    group.type.toUpperCase() === type.toUpperCase();

export const orphanIsPresent = (
  entityId: string
): BoidGroupPredicate<BoidAllocation> => {
  return group =>
    Object.values(group.boids).some(
      state => statusFor(state, entityId) === "orphaned"
    );
};
